const testCep = (cep) => {
  const errorMessages = {
    messages: [
      {text: 'CEP não encontrado.'},
      {text: 'Por favor, digite um Cep válido.'}
    ]
  };
  if (cep.length !== 8) throw errorMessages;
};

export const cepNotFounded = () => {
  const errorMessages = {
    messages: [{text: 'CEP inválido.'}]
  };
  return errorMessages;
};

export const cepValidator = (cep) => {
  try {
    testCep(cep);
    return {status: true, address: cep};
  } catch (error) {
    return {status: false, address: '', error};
  }
};
